import { render, staticRenderFns } from "./Employees.vue?vue&type=template&id=51e004be&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=ts"
export * from "./Employees.vue?vue&type=script&lang=ts"
import style0 from "./Employees.vue?vue&type=style&index=0&id=51e004be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e004be",
  null
  
)

export default component.exports